module.exports = __webpack_public_path__ + "img/camera-solid.b16e278e.svg";